import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const SimpleModal = (props) => {
  const { close, content, isModalDialogOpen, title } = props

  return (
    <Modal size={'lg'} show={isModalDialogOpen} onHide={() => close()}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ wordWrap: 'break-word' }}>{content}</Modal.Body>
      <Modal.Footer>
        <Button onClick={() => close()} variant={'default'}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SimpleModal
